import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';

let isRefreshing = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401 && !req.url.includes('/auth/refresh') && !req.url.includes('/auth/login')) {
        if (!isRefreshing) {
          isRefreshing = true;
          return authService.refreshToken().pipe(
            switchMap(() => {
              isRefreshing = false;
              const token = authService.getToken();
              const retryReq = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` },
              });
              return next(retryReq);
            }),
            catchError((refreshError) => {
              isRefreshing = false;
              authService.logout();
              return throwError(() => refreshError);
            }),
          );
        }
        return throwError(() => error);
      }

      if (error.status === 403) {
        toastService.error('No tienes permisos para realizar esta acción');
      } else if (error.status === 404) {
        toastService.error('El recurso solicitado no fue encontrado');
      } else if (error.status === 422) {
        const message = error.error?.error?.message || 'Datos inválidos';
        toastService.error(message);
      } else if (error.status >= 500) {
        toastService.error('Error del servidor. Intenta nuevamente más tarde');
      } else if (error.status === 0) {
        toastService.error('Error de conexión. Verifica tu conexión a internet');
      }

      return throwError(() => error);
    }),
  );
};
